import { format } from 'date-fns';

import { userLocaleTimezone } from '@/lib/utils';

export const formatSiteDetailDate = (value: string | null) => {
  if (!value) {
    return 'N/A';
  }

  return new Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
};

export const formatSiteDetailEvaluationGeneratedAt = (value: string | null) => {
  if (!value) {
    return 'N/A';
  }

  return `${format(new Date(value), 'yyyy-MM-dd HH:mm')} ${userLocaleTimezone()}`;
};

export const getSiteDetailScoreIndicatorColorClass = (
  score: number | null | undefined,
) => {
  if (score === null || score === undefined) {
    return 'bg-gray-400';
  }

  return score === 100 ? 'bg-green-500' : 'bg-red-500';
};
